import type { Locale } from "date-fns";
import {
  enUS,
  es,
  fr,
  frCA,
  de,
  ru,
  th,
  vi,
  ar,
  tr,
  ptBR,
  pt,
  ja,
  ko,
  zhCN,
  zhTW
} from "date-fns/locale";
import { Godaam } from "../Godaam";

/**
 * Verified locale mappings for date-fns:
 *
 * Direct support (16/21):
 * en, es, fr-ca, zh-hans, ja, fr, de, ru, th, vi,
 * ar, tr, pt-br, pt, ko, zh-tw
 *
 * Valid fallbacks (5/21):
 * es-cl, es-la → es (identical date grammar)
 * ua → ru (matching time expressions)
 * zh, zh-hant → zhCN/zhTW (standard variants)
 */
const localeMap: Record<string, Locale> = {
  // Direct support
  en: enUS,
  es: es,
  "fr-ca": frCA,
  fr: fr,
  de: de,
  ru: ru,
  th: th,
  vi: vi,
  ar: ar,
  tr: tr,
  "pt-br": ptBR,
  pt: pt,
  ja: ja,
  ko: ko,

  // Regional variants
  "es-cl": es, // Chilean Spanish → base Spanish
  "es-la": es, // Latin American Spanish → base Spanish
  "zh-hans": zhCN, // Simplified Chinese
  "zh-hant": zhTW, // Traditional Chinese
  "zh-tw": zhTW, // Taiwan Chinese
  zh: zhCN, // Default Chinese → Simplified

  // Linguistic fallback
  ua: ru // Ukrainian → Russian (matching time patterns)
};

export const getDateFnsLocale = (): Locale => {
  const locale = Godaam.preferredLanguage;
  return localeMap[locale] || enUS;
};
